import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../pipes/translate.pipe';

interface OrganizationNode {
  id: string;
  name: string;
  type: 'company' | 'department' | 'user';
  children?: OrganizationNode[];
  role?: string;
  companyid?: string;
  assistantNo?: string;
  expanded?: boolean;
  userCount?: number;
  users?: any[];
  isMoving?: boolean; // 新增：用於視覺反饋
}

@Component({
  selector: 'app-organization-management-tree-node',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './organization-management-tree-node.component.html',
  styleUrls: ['./organization-management-tree-node.component.scss']
})
export class OrganizationManagementTreeNodeComponent {
  @Input() node!: OrganizationNode;
  @Input() parent: OrganizationNode | null = null;
  @Input() siblings: OrganizationNode[] = [];
  @Input() nodeIndex: number = 0;
  @Input() level: number = 0;
  
  @Output() moveUp = new EventEmitter<OrganizationNode>();
  @Output() moveDown = new EventEmitter<OrganizationNode>();
  @Output() editNode = new EventEmitter<OrganizationNode>();
  @Output() addChild = new EventEmitter<OrganizationNode>();
  @Output() deleteNode = new EventEmitter<OrganizationNode>();
  @Output() toggleExpanded = new EventEmitter<OrganizationNode>();

  onMoveUp() {
    this.node.isMoving = true;
    this.moveUp.emit(this.node);
    // 短暫高亮顯示後恢復
    setTimeout(() => {
      if (this.node) {
        this.node.isMoving = false;
      }
    }, 1000);
  }

  onMoveDown() {
    this.node.isMoving = true;
    this.moveDown.emit(this.node);
    // 短暫高亮顯示後恢復
    setTimeout(() => {
      if (this.node) {
        this.node.isMoving = false;
      }
    }, 1000);
  }

  onEdit() {
    this.editNode.emit(this.node);
  }

  onAddChild() {
    this.addChild.emit(this.node);
  }

  onDelete() {
    this.deleteNode.emit(this.node);
  }

  toggleNode() {
    this.node.expanded = !this.node.expanded;
    this.toggleExpanded.emit(this.node);
  }

  getNodeIconClass(): string {
    if (this.node.type === 'company') {
      return 'fas fa-building';
    }
    
    switch (this.level) {
      case 1: return 'fas fa-folder-open';
      case 2: return 'fas fa-folder';
      case 3: return 'fas fa-folder-minus';
      default: return 'fas fa-folder-plus';
    }
  }

  getNodeClass(): string {
    let baseClass = '';
    
    if (this.node.type === 'company') {
      baseClass = 'company-node';
    } else {
      switch (this.level) {
        case 1: baseClass = 'department-node'; break;
        case 2: baseClass = 'sub-department-node'; break;
        case 3: baseClass = 'sub-sub-department-node'; break;
        default: baseClass = 'deep-department-node'; break;
      }
    }
    
    // 添加移動動畫類別
    if (this.node.isMoving) {
      baseClass += ' moving';
    }
    
    return baseClass;
  }

  getDepartmentChildren(): OrganizationNode[] {
    if (!this.node.children) return [];
    return this.node.children.filter(child => child.type === 'department');
  }

  isExpandable(): boolean {
    return this.getDepartmentChildren().length > 0;
  }

  canMoveUp(): boolean {
    return this.nodeIndex > 0;
  }

  canMoveDown(): boolean {
    return this.nodeIndex < this.siblings.length - 1;
  }
}